import Button from '../Button';
import './InstallModal.scss';

const InstallModal = ({onInstall, ...props}) => {
    return(
        <div className="InstallModal-container">
            <div className="backdrop"></div>
            <div className="install-modal">
                <div className="install-text">Do you want to install the app?</div>
                <div className="btn-container">
                    <Button value="Install" onClick={onInstall} />
                </div>
                
            </div>
        </div>
    )
}

export default InstallModal;